import { KibContainer } from '@chewy/kib-layout-react'

import { ClinicNotesSection } from '../components/ClinicNotesSection'
import { DeliverySection } from '../components/DeliverySection'
import { MessageBodySection } from '../components/MessageBodySection'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './PaymentRequestScreen.module.scss'

export const PaymentRequestScreen = ({
  isFormValid,
  setIsFormValid,
}: {
  isFormValid: boolean
  setIsFormValid: (isValid: boolean) => void
}) => (
  <KibContainer className={styles.paymentRequestScreenContainer}>
    <DeliverySection />
    <MessageBodySection />
    <ClinicNotesSection
      isFormValid={isFormValid}
      setIsFormValid={setIsFormValid}
    />
  </KibContainer>
)
